(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[758],{

/***/ 3031:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-lesson",
      function () {
        return __webpack_require__(9652);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5002:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const data = {
    links: {
        freePythonLectureRegistration: "https://forms.gle/BZyWuCnFAUvKbDot5",
        generalRegistrationForm: "https://formfaca.de/sm/QwkYhS7Wm"
    },
    courseTopics: [
        {
            id: "pb",
            name: "Python pradedantiesiems",
            description: "Course for someone",
            price: 400,
            hours: 40
        }
    ],
    courses: [
        {
            isPopular: true,
            id: "p-b",
            name: "Python pradedantiesiems",
            tags: [
                "python",
                "data-analysis",
                "beginner"
            ],
            type: "Dieninis",
            days: "PATKPxx",
            groupSize: [
                8,
                16
            ],
            intensity: 40,
            price: 330,
            hours: 40,
            startDate: "2022-11-21",
            description: "Python yra populiariausia pasaulyje programavimo kalba. Python kodas yra lengvai skaitomas, o taikymo sričių - begalė, įskaitant tinklalapių kūrimą, mašininį mokymąsį, automatizavimą ir t.t. Šis kursas puikiai tinka norintiems įgauti Python programavimo pagrindus ir pasirinkti tolimesnę kryptį.",
            // descriptionExtra:
            //   "Šis kursas yra paremtas partnerių, pagal jį paruošta 500 studentų Vokietijoje.",
            link: "python-beginner",
            active: true,
            // https://schema.org/CourseInstance
            courseInstances: [
                // {
                //   courseMode: "online",
                //   startDate: "2022-11-28",
                //   endDate: "2022-12-02",
                //   isAccessibleForFree: false,
                //   courseWorkload: "40 kontaktinių valandų",
                //   instructor: { "@type": "Person", name: "Aidis Stukas" },
                //   eventAttendanceMode: "online",
                //   organizer: { "@type": "Organization", name: "Pirmas kodas" },
                //   offers: {
                //     "@type": "Offer",
                //     availability: "https://schema.org/InStock",
                //     price: 330,
                //     priceCurrency: "EUR",
                //     // url: "http://www.ticketfly.com/purchase/309433",
                //   },
                //   extraType: "dieninė",
                //   extraTypeEmoji: "🏙️",
                //   extraDayTime: "DD, 09:00-17:00 su pertrauka",
                //   // Todo later
                //   // eventSchedule: {},
                // },
                // {
                //   courseMode: "online",
                //   startDate: "2023-01-23",
                //   endDate: "2023-02-17",
                //   isAccessibleForFree: false,
                //   courseWorkload: "40 kontaktinių valandų",
                //   instructor: { "@type": "Person", name: "Aidis Stukas" },
                //   eventAttendanceMode: "online",
                //   organizer: { "@type": "Organization", name: "Pirmas kodas" },
                //   offers: {
                //     "@type": "Offer",
                //     availability: "https://schema.org/InStock",
                //     price: 330,
                //     priceCurrency: "EUR",
                //     // url: "http://www.ticketfly.com/purchase/309433",
                //   },
                //   extraType: "vakarinė",
                //   extraTypeEmoji: "🌆",
                //   extraDayTime: "DD, 18:00-20:00",
                //   // Todo later
                //   // eventSchedule: {},
                //   order: 2,
                // },
                // {
                //   courseMode: "online",
                //   startDate: "2023-01-28",
                //   endDate: "2022-02-19",
                //   isAccessibleForFree: false,
                //   courseWorkload: "40 kontaktinių valandų",
                //   instructor: { "@type": "Person", name: "Aidis Stukas" },
                //   eventAttendanceMode: "online",
                //   organizer: { "@type": "Organization", name: "Pirmas kodas" },
                //   offers: {
                //     "@type": "Offer",
                //     availability: "https://schema.org/InStock",
                //     price: 330,
                //     priceCurrency: "EUR",
                //     // url: "http://www.ticketfly.com/purchase/309433",
                //   },
                //   extraType: "savaitgalinė",
                //   extraTypeEmoji: "☀️",
                //   extraDayTime: "Šeštadieniais, 10:00-13:00",
                //   // Todo later
                //   // eventSchedule: {},
                //   order: 2,
                // },
                {
                    courseMode: "online",
                    startDate: "2023-03-27",
                    endDate: "2023-04-14",
                    isAccessibleForFree: false,
                    courseWorkload: "40 kontaktinių valandų",
                    instructor: {
                        "@type": "Person",
                        name: "Aidis Stukas"
                    },
                    eventAttendanceMode: "online",
                    organizer: {
                        "@type": "Organization",
                        name: "Pirmas kodas"
                    },
                    offers: {
                        "@type": "Offer",
                        availability: "https://schema.org/InStock",
                        price: 600,
                        priceCurrency: "EUR"
                    },
                    extraType: "dieninė",
                    extraTypeEmoji: "\uD83C\uDFD9️",
                    extraDayTime: "10:00-12:00 darbo dienomis",
                    // Todo later
                    // eventSchedule: {},
                    order: 1
                }
            ],
            position: 1
        },
        {
            id: "p-da",
            name: "Duomenų analizė su Python",
            tags: [
                "python",
                "data-analysis",
                "pandas",
                "machine-learning"
            ],
            type: "Vakarinis",
            days: "PATKPxx",
            intensity: 40,
            price: 800,
            hours: 80,
            startDate: "2022-10-02",
            endDate: "2022-10-20",
            description: "Python programavimo kalba yra lyderė duomenų analizės srityje. Versle Python keičia ir papildo Excel bei kitas duomenų analizės priemonės. Baigę šį kursą galėsite mikliai naršyti, tvarkyti, analizuoti ir pristatyti duomenis su Python. Baigę šį kursą galėsite studijuoti mašininį mokymąsį.",
            link: "duomenu-analitika-su-python",
            active: true,
            position: 2
        },
        {
            id: "p-ds",
            name: "Duomenų mokslas ir mašininis mokymasis su Python",
            tags: [
                "python",
                "data-analysis",
                "pandas",
                "machine-learning"
            ],
            type: "Vakarinis",
            days: "PATKPxx",
            intensity: 40,
            price: 1200,
            hours: 80,
            startDate: "2022-10-02",
            endDate: "2022-10-20",
            description: "Tai žingsnis po duomenų analitikos. Susipažinsime su mašininiu mokymusi. Įvaldysime sklearn biblioteką. Susipažinsime su Xgboost, LightGbm bei neuroninių tinklų bibliotekomis (TensorFlow, Pytorch).",
            link: "masininis-mokymasis-su-python",
            active: true,
            position: 3
        },
        {
            id: "p-wd-be",
            name: "Backend Web dev su Python (Django arba FastAPI)",
            tags: [
                "python",
                "data-analysis",
                "pandas",
                "machine-learning"
            ],
            type: "Vakarinis",
            days: "PATKPxx",
            intensity: 40,
            price: 800,
            hours: 80,
            description: "Norite kurti web aplikacijas? Python turi bent keletą tam skirtų bibliotekų. Šis kursas labiausiai tinka tiems, kurie mėgsta dirbi su duomenimis ir neturi noro gilintis į dizainą ir UX/UI klausimus. Baigę šį kursą galėsite kuri web aplikacijų backend dalį.",
            link: "tinklalapiu-kurimas-su-python",
            active: true,
            position: 4
        },
        {
            id: "p-wd-fs",
            name: "Full stack Web dev su Python ir Javascript (React, Tailwind)",
            tags: [
                "python",
                "data-analysis",
                "pandas",
                "machine-learning"
            ],
            type: "Vakarinis",
            days: "PATKPxx",
            intensity: 40,
            price: 1500,
            hours: 120,
            description: "Full-stackeris žmogus, kuris dažniausiai reikalingas mažoms ir/arba judrioms(agile) kompanijoms. Esant poreikiui galėsite sukurti visą aplikaciją arba galėsite specializuotis į viena iš sričių bet tuo pačiu suprast ką daro kolegos 'kitame gale'.",
            link: "tinklalapiu-kurimas-su-python-ir-react",
            active: true,
            position: 5
        },
        {
            id: "p-ws",
            name: "Web scraping su Python",
            tags: [
                "python",
                "data-analysis",
                "pandas",
                "machine-learning"
            ],
            type: "Vakarinis",
            days: "PATKPxx",
            intensity: 40,
            price: 400,
            hours: 40,
            description: "Dažnas IT projektas priklauso nuo duomenų. Vieša paslaptis, kad didelė dalis kompanijų duomenis tiesiog renka iš interneto. Tai sena praktika, bet besikeičianti kiekvienais metais. Išmoksime įvairių scraping technikų. Baigę kursą galėsite sukurti sprendimą kuris nuolat tvarkingai ir patikimai surenka duomenis iš vieno ar net kelių šaltinių.",
            link: "web-scraping-su-python",
            active: true,
            position: 6
        }
    ]
};
/* harmony default export */ __webpack_exports__["Z"] = (data);


/***/ }),

/***/ 9652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2962);
/* harmony import */ var _components_data__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5002);




const About = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
                title: "Nemokama Python pamoka | Pirmas kodas",
                description: "Pirmas kodas siūlo sudalyvauti nemokamoje pamokoje"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
                className: "prose dark:prose-invert",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: "Nemokama Python pamoka"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: "Kiekvieną pirmadienį, 17:00 val. vedame nemokamas programavimo su Python pamokas."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: "Viso siūlome 4 nemokamų pamokų tipus"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: "Įvadas į Python"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: "Duomenų analizė su Python (Pandas)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: "Mašininis mokymasis su Python (sklearn, lightgbm, tensorflow, pytorch) "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: "Tinklalapių kūrimas (Web API, backend, FastAPI, Django, Flask)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: "Sudomino? Kviečiu užpildyti formą. Gavę Jūsų atsakymus atsiūsime pakvietimą į pamoką Jus dominančia tema!"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "rounded-md bg-mustard p-3 text-lg font-bold dark:bg-green-500 dark:text-black",
                            href: _components_data__WEBPACK_IMPORTED_MODULE_3__/* ["default"].links.freePythonLectureRegistration */ .Z.links.freePythonLectureRegistration,
                            rel: "noopener noreferrer",
                            target: "_blank",
                            children: "Registruotis"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (About);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [962,774,888,179], function() { return __webpack_exec__(3031); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);